import { Injectable, Signal, signal } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class LoadingService {
    readonly isLoading: Signal<boolean>;
    readonly loadingMessage: Signal<string | undefined>;
    readonly fade: Signal<boolean>;

    private _isLoading = signal(false);
    private _loadingMessage = signal<string | undefined>(undefined);
    private _fade = signal(false);

    constructor() {
        this.isLoading = this._isLoading.asReadonly();
        this.loadingMessage = this._loadingMessage.asReadonly();
        this.fade = this._fade.asReadonly();
    }

    show(message?: string): void {
        this._fade.set(true);
        this._loadingMessage.set(message);
        setTimeout(() => {
            this._isLoading.set(true);
        }, 0);
    }

    hide(): void {
        this._fade.set(false);
        setTimeout(() => {
            this._isLoading.set(false);
            this._loadingMessage.set(undefined);
        }, 350);
    }

    async withLoading<T>(action: () => Promise<T>, message?: string): Promise<T> {
        this.show(message);
        try {
            return await action();
        } finally {
            this.hide();
        }
    }
}
